import { useContext, useEffect, useState } from 'react'
import { CButton, CCard, CCardBody, CCardHeader, CCardTitle, CCol, CCollapse, CDropdown, CDropdownItem, CDropdownMenu, CDropdownToggle, CRow } from '@coreui/react-pro';
import Path from './componenet.path';
import Table from './componenet.table';
import { useNavigate, useSearchParams } from 'react-router-dom';
import FilterSorting from './component.filter.sorting';
import ScrollToTop from 'react-scroll-to-top';
import { AppContext } from '../../contexts/App';
import CIcon from '@coreui/icons-react';
import { cilArrowTop, cilPlus, cisChevronBottom, cisChevronTop } from '@coreui/icons-pro';

const Index = () => {
    const { setMetaData, theme } = useContext(AppContext)
    const navigate = useNavigate()
    const [searchParams] = useSearchParams();
    const [collapseFilterSorting, setCollapseFilterSorting] = useState(searchParams.has('name') ||
        searchParams.has('is_sub') ||
        searchParams.has('is_active') ||
        searchParams.has('ordering') ||
        searchParams.has('parent')
    )

    useEffect(() => {
        setMetaData({
            title: "Data Akun",
        })
    }, [setMetaData])

    return (<>
        <CRow>
            <CCol>
                <CDropdown variant="btn-group" >
                    <CDropdownToggle color={'primary'} size='sm' className='me-2 mb-3'><CIcon icon={cilPlus} className='me-1' />Add</CDropdownToggle>
                    <CDropdownMenu>
                        <CDropdownItem href="" onClick={(e) => {
                            const newSP = new URLSearchParams()
                            navigate({ pathname: "add", search: newSP.toString() })
                        }}>Akun</CDropdownItem>
                        <CDropdownItem href="" onClick={(e) => {
                            const newSP = new URLSearchParams()
                            navigate({ pathname: "addsub", search: newSP.toString() })
                        }}>Sub Akun</CDropdownItem>
                    </CDropdownMenu>
                </CDropdown>
                <CButton active={collapseFilterSorting} color={'primary'} size='sm' className='me-2 mb-3' onClick={() => {
                    setCollapseFilterSorting(x => !x)
                }}> Filter & Sorting <CIcon className='ms-1' icon={collapseFilterSorting ? cisChevronBottom : cisChevronTop} /></CButton>
            </CCol>
        </CRow>
        <CCollapse visible={collapseFilterSorting}>
            <CRow className='mb-3'>
                <CCol>
                    <CCard>
                        <CCardHeader>
                            Filter & Sorting
                        </CCardHeader>
                        <CCardBody>
                            <FilterSorting />
                        </CCardBody>
                    </CCard>
                </CCol>
            </CRow>
        </CCollapse>
        <CRow>
            <CCol>
                <CCard>
                    <CCardHeader>
                        <Path rootPath='/akun' />
                    </CCardHeader>
                    <CCardBody>
                        <Table />
                    </CCardBody>
                </CCard>
            </CCol>
        </CRow>

        <ScrollToTop smooth component={<CIcon icon={cilArrowTop} />} className={`rounded-circle bg-${theme}`} />
    </>)
}

export default Index